import { ErrorResponse } from 'src/app/models/core/error-response.model';

export function getErrorText(error: ErrorResponse): string {
  return typeof error.error === 'string'
    ? (JSON.parse(error.error)?.detail ?? 'errorsMessages.tryAgain')
    : (error.error?.detail ?? error.message ?? 'errorsMessages.tryAgain');
}

export function getErrorAdditionalInfo(error: ErrorResponse): any {
  if (typeof error.error === 'string') {
    return null;
  }
  return error.error?.additionalInfo;
}
